import i18n from '@/i18n'

/**
 * Pick the locale-appropriate half of a bilingual data field.
 *
 * Most tenant entities are stored as pairs — `titleEn`/`titleAr`,
 * `nameEn`/`nameAr`, `descriptionEn`/`descriptionAr` — but the admin UI was
 * written to always render the `En` half. In Arabic that left real content
 * (plan names, category names, area names) in English even though the Arabic
 * text was already in the database and already returned by the API.
 *
 * Falls back to the English value whenever the Arabic one is missing or blank,
 * which is common: many tenants only fill the English column. That makes this
 * safe to apply everywhere — the worst case is exactly today's behaviour.
 *
 * @param {object} item  the entity, e.g. a package row
 * @param {string} base  field name without the language suffix, e.g. "title"
 * @returns {string}
 */
export function localizedField (item, base) {
  if (!item || !base) return ''
  const en = item[`${base}En`]
  if (i18n.locale !== 'ar') return en == null ? '' : en
  const ar = item[`${base}Ar`]
  if (typeof ar === 'string' && ar.trim()) return ar
  if (ar != null && typeof ar !== 'string') return ar
  return en == null ? '' : en
}

export default localizedField
